import React, { useState, useEffect } from 'react';
import { API_URL } from '../utils/Functions';
import { primaryLinks, secondaryLinks } from './Navbar';

const Footer = () => {
  const [dynamicPages, setDynamicPages] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/public/menus`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setDynamicPages(data.data || []);
        }
      })
      .catch(err => console.error('Failed to load menus', err));
  }, []);

  return (
    <footer className="text-white" style={{ backgroundColor: '#061830', borderTop: '4px solid #CFA047' }}>
      <div className="pt-5 pb-4">
        <div className="container text-start">
          <div className="row g-4">
            <div className="col-lg col-md-4 col-sm-6">
              <h6 className="fw-bold mb-3 text-white" style={{ fontSize: '14px' }}>Quick Links</h6>
              <ul className="list-unstyled d-flex flex-column gap-2" style={{ fontSize: '13px' }}>
                {secondaryLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className="text-decoration-none text-white opacity-75 hover-opacity-100 transition" style={{ transition: 'opacity 0.2s' }}>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            {primaryLinks.map((category, index) => {
              const linkPages = dynamicPages.filter(p => p.menu_title === category.label);
              return (
                <div key={index} className="col-lg col-md-4 col-sm-6">
                  <h6 className="fw-bold mb-3 text-white" style={{ fontSize: '14px' }}>
                    <span className="text-white text-decoration-none">{category.label}</span>
                  </h6>
                  <ul className="list-unstyled d-flex flex-column gap-2" style={{ fontSize: '13px' }}>
                    {linkPages.map(page => (
                      <li key={page.id}>
                        <a href={`/pages/${page.slug}`} className="text-decoration-none text-white opacity-75 hover-opacity-100 transition" style={{ transition: 'opacity 0.2s' }}>
                          {page.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
          
          <div className="row mt-5 pt-4 border-top border-light border-opacity-10">
            <div className="col-md-6 text-start">
              <p className="text-white opacity-75 m-0 mb-2 mb-md-0" style={{ fontSize: '12px' }}>
                For support or complaints, email us at: <a href="mailto:help@legalinfos.in" className="text-white text-decoration-none fw-semibold">help@legalinfos.in</a>
              </p>
            </div>
            <div className="col-md-6 text-start text-md-end">
              <div className="d-flex flex-wrap gap-2 justify-content-start justify-content-md-end" style={{ fontSize: '12px' }}>
                <span className="text-white opacity-75">
                  Powered by <a href="https://safprotech.com/" target="_blank" rel="noreferrer" className="text-decoration-none" style={{ color: '#CFA047', fontWeight: 700 }}>SAFPRO TECHNOLOGY SOLUTIONS</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
